const flipCards = () => {
  document.addEventListener('click', (event) => {
    const { target } = event;
    const animateSelector = 'flip-animation';
    const showCardFacesSelector = 'show-card-faces';
    const isFlippedSelector = 'is-flipped';
    const is0 = target.closest('.flip-0-btn');
    const is180 = target.closest('.flip-180-btn');
    const card = target.closest('.flip-card');
    if (is180 || is0) {
      card.classList.toggle(animateSelector);
      card.classList.add(showCardFacesSelector);
      setTimeout(() => {
        card.classList.toggle(isFlippedSelector);
        card.classList.remove(showCardFacesSelector);
      }, 300);
    }
  });
};

export default flipCards;
